import { computePosition, shift } from "@floating-ui/dom";
import { EventEmitter } from "../../utils";
import { events } from "../../scripts/constants";

export default function initTooltips() {
  const tooltips = document.querySelectorAll<HTMLElement>(".tooltip");
  tooltips.forEach((tooltip) => {
    if (tooltip.dataset.tooltipInit === "true") return;

    const trigger = tooltip.querySelector<HTMLElement>(".tooltip__icon");
    const content = tooltip.querySelector<HTMLElement>(".tooltip__content");

    if (!trigger || !content) return;

    const update = () => {
      computePosition(trigger, content, {
        placement: "bottom",
        middleware: [shift({ padding: 10 })],
      }).then(({ x, y }) => {
        Object.assign(content.style, {
          left: `${x}px`,
          top: `${y + 10}px`,
        });
      });
    };

    trigger.addEventListener("click", () => {
      content.classList.toggle("visible");
      update();
    });

    document.addEventListener("click", (event) => {
      if (!tooltip.contains(event.target as Node)) {
        content.classList.remove("visible");
      }
    });
    tooltip.dataset.tooltipInit = "true";
  });
}

EventEmitter.on(events.R4R_REFRESH, () => {
  initTooltips();
});
